import React from 'react';
import { StatusIndicator } from '../../components/StatusIndicator/StatusIndicator';

const STATUS_MAP = {
  SENT:    { tone: 'success', label: 'Envoyé' },
  FAILED:  { tone: 'danger',  label: 'Échec' },
  BLOCKED: { tone: 'warn',    label: 'Bloqué' },
  PENDING: { tone: 'faded',   label: 'En attente' },
};

export function ContactStatusBadge({ status, size = 'md', uppercase = false, className }) {
  const cfg = STATUS_MAP[status] || STATUS_MAP.PENDING;
  return (
    <StatusIndicator tone={cfg.tone} size={size} uppercase={uppercase} className={className}>
      {cfg.label}
    </StatusIndicator>
  );
}

export default ContactStatusBadge;
